// Hooks
import { useOrm } from 'shared/utils/useOrm'
import { useSettings } from 'shared/utils/useSettings'
import { useSelector } from 'react-redux'

// Shared
import previewUrlComposer from 'shared/utils/previewUrlComposer'

export const useCart = () => {
  const cartId = useSelector((state) => state.client.cartId)
  const companySlug = useSelector((state) => state.client.getIn(['company', 'slug']))

  const cart = useOrm('carts', (carts) => carts.getById(cartId))

  const taxStrategy = useSettings('pricing.tax_strategy')
  const showPrices = useSettings('store.use_prices')

  const currency = useSelector((state) => state.client.currency)

  const isOverdue = useSelector((state) => state.client.cartOverdue)
  const isEmpty = useOrm('lines', (lines) => {
    return lines.getAll({
      id: cart?.lines,
      product_type: ['rental', 'consumable', 'sales_item', 'bundle']
    }).size() === 0
  })

  const searchParams = new URLSearchParams(window.location.search)
  const viewCartHref = window.booqableOptions.preview ?
    previewUrlComposer({ slug: companySlug, themeId: searchParams.get('theme_id'), key: 'templates/cart.json' }) :
    cart?.cart_url

  let totalPriceAttribute

  if (taxStrategy === 'inclusive') {
    totalPriceAttribute = 'grand_total_with_tax_in_cents'
  } else {
    totalPriceAttribute = 'grand_total_in_cents'
  }

  return {
    cart,
    totalPriceAttribute,
    showPrices,
    taxStrategy,
    currency: currency?.toJS(),
    isOverdue,
    isEmpty,
    viewCartHref
  }
}
